import React from 'react';
import styles from './QuestsGuide.module.css';
import QuestCard from './QuestsCard';
import {QuestData} from './model';
import {Trans, useTranslation} from "react-i18next";

const QuestsGuide: React.FC = () => {
    const {t} = useTranslation();


    const questsData: QuestData[] = [
        {
            number: 1,
            title: t('quest_1'),
            options: [
                {
                    number: 1,
                    videoLinks: [{number: 1, url: 'https://satoshiapp.xyz/hubfs/Pell/Step1_Discord.mp4'}],
                    title: t('quest_1_option_4_title'),
                    buttonLink: 'https://discord.com/invite/pell-network',
                    buttonText: t('claim'),
                    description: t('quest_1_option_4_desc')
                },
                {
                    number: 2,
                    videoLinks: [{number: 1, url: 'https://satoshiapp.xyz/hubfs/Pell/Step1_WebCore.mp4'}],
                    title: t('quest_1_option_1_title'),
                    buttonText: t('claim'),
                    buttonLink: 'https://scan.test.btcs.network/faucet',
                    description: t('quest_1_option_1_desc'),
                    descriptionKey: 'quest_1_option_1_desc'
                },
                {
                    number: 3,
                    videoLinks: [{number: 1, url: 'https://satoshiapp.xyz/hubfs/Pell/Step1_WebBNB.mp4'}],
                    title: t('quest_1_option_2_title'),
                    buttonText: t('claim'),
                    buttonLink: 'https://www.bnbchain.org/en/testnet-faucet',
                    description: t('quest_1_option_2_desc'),
                    descriptionKey: 'quest_1_option_2_desc'
                },
                {
                    number: 4,
                    videoLinks: [{number: 1, url: 'https://satoshiapp.xyz/hubfs/Pell/Step1_WebMantle.mp4'}],
                    title: t('quest_1_option_3_title'),
                    buttonText: t('claim'),
                    buttonLink: 'https://faucet.quicknode.com/mantle',
                    description: t('quest_1_option_3_desc'),
                    descriptionKey: 'quest_1_option_3_desc'
                }
            ]
        },
        {
            number: 2,
            title: t('quest_2'),
            importantNote: t('quest_2_important'),
            options: [
                {
                    number: 1,
                    videoLinks: [
                        {number: 1, title: 'Core Testnet', url: 'https://satoshiapp.xyz/hubfs/Pell/Step2_WebCore.mp4'},
                        {
                            number: 2,
                            title: 'BNB Chain Testnet',
                            url: 'https://satoshiapp.xyz/hubfs/Pell/Step2_WebBNB.mp4'
                        },
                        {
                            number: 3,
                            title: 'Mantle Testnet',
                            url: 'https://satoshiapp.xyz/hubfs/Pell/Step2_WebMantle.mp4'
                        },
                    ],
                    buttonText: t('claim'),
                    buttonLink: 'https://test.pell.network/faucet',
                    description: t('quest_2_option_1_desc'),
                    descriptionKey: 'quest_2_option_1_desc'
                }
            ],
        },
        {
            number: 3,
            title: t('quest_3'),
            options: [
                {
                    number: 1,
                    videoLinks: [
                        {number: 1, title: 'Core Testnet', url: 'https://satoshiapp.xyz/hubfs/Pell/Step3_WebCore.mp4'},
                        {
                            number: 2,
                            title: 'BNB Chain Testnet',
                            url: 'https://satoshiapp.xyz/hubfs/Pell/Step3_WebBNB.mp4'
                        },
                        {
                            number: 3,
                            title: 'Mantle Testnet',
                            url: 'https://satoshiapp.xyz/hubfs/Pell/Step3_WebMantle.mp4'
                        },
                    ],
                    buttonText: t('restake'),
                    buttonLink: 'https://test.pell.network/restake',
                    description: t('quest_3_option_1_desc'),
                    descriptionKey: 'quest_3_option_1_desc'
                }
            ],
        },
        {
            number: 4,
            title: t('quest_4'),
            options: [
                {
                    number: 1,
                    videoLinks: [
                        {number: 1, title: 'Core Testnet', url: 'https://satoshiapp.xyz/hubfs/Pell/Step4_WebCore.mp4'},
                        {
                            number: 2,
                            title: 'BNB Chain Testnet',
                            url: 'https://satoshiapp.xyz/hubfs/Pell/Step4_WebBNB.mp4'
                        },
                        {
                            number: 3,
                            title: 'Mantle Testnet',
                            url: 'https://satoshiapp.xyz/hubfs/Pell/Step4_WebMantle.mp4'
                        },
                    ],
                    buttonText: t('delegate'),
                    buttonLink: 'https://test.pell.network/operator',
                    description: t('quest_4_option_1_desc'),
                    descriptionKey: 'quest_4_option_1_desc'
                }
            ],
        },
        {
            number: 5,
            title: t('quest_5'),
            options: [
                {
                    number: 1, buttonText: t('follow'),
                    buttonLink: 'https://x.com/Pell_Network',
                    description: t('quest_5_option_1_desc')
                }
            ],
        },
        {
            number: 6,
            title: t('quest_6'),
            options: [
                {
                    number: 1,
                    videoLinks: [{number: 1, url: 'https://satoshiapp.xyz/hubfs/Pell/Step6.mp4'}],
                    buttonText: t('join'),
                    buttonLink: 'https://discord.com/invite/pell-network',
                    description: t('quest_6_option_1_desc')
                }
            ],
        },
        {
            number: 7,
            title: t('quest_7'),
            options: [
                {
                    number: 1,
                    buttonText: t('join'),
                    buttonLink: 'https://t.me/GemCoinAPP_bot/GemCoin?startapp=PVdaLy4pDL',
                    description: t('quest_7_option_1_desc')
                }
            ],
        },
        {
            number: 8,
            title: t('quest_8'),
            importantNote: t('quest_8_important'),
            options: [
                {
                    number: 1,
                    videoLinks: [{number: 1, url: 'https://satoshiapp.xyz/hubfs/Pell/Step8.mp4'}],
                    buttonText: t('submit'),
                    buttonLink: 'https://satoshiapp.xyz/en/download-app',
                    description: t('quest_8_option_1_desc')
                }
            ],
        }

    ];

    return (
        <section className={styles.container}>
            <header className={styles.header}>
                <h1 className={styles.title}>{t('stepBy')}</h1>
                <p className={styles.description}>
                    <Trans i18nKey={'questComplete'}/>
                </p>
            </header>
            <div className={styles.questsContainer}>
                {questsData.map((quest, index) => (
                    <QuestCard key={index} quest={quest}/>
                ))}
            </div>
        </section>
    );
};

export default QuestsGuide;